/* MXDVS homepage sections v3, 28.09.2026
   Used by: mxdvs-collection, mxdvs-video, mxdvs-edition-ledger, mxdvs-closing-strip
   v5: amounts always with two decimals unless whole, black and white glitch,
   pull a file on phones matched to the height of the freebie track.
   v6: release and last sold dates (templates/product.mxdvs-file.liquid), photo as tall as the text.
   v7: release date fix (no JSON Accept header, fallback to Shopify's dates), Open file decodes in.
   Card behaviour (decode on hover, sale decode, fade-in) lives in assets/mxdvs-card.js.
   Delegated listeners plus custom elements, so everything starts again by itself
   when a section reloads in the theme editor. Every section loads this file;
   the guard below makes sure it only runs once. */
(function () {
  if (window.MxHome) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function pad(n, len) {
    n = String(n);
    while (n.length < (len || 2)) n = '0' + n;
    return n;
  }
  function group(s) {
    return String(s).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function define(name, cls) {
    if (!customElements.get(name)) customElements.define(name, cls);
  }
  function decode(el, text, ms) {
    if (window.MxCard) {
      window.MxCard.decode(el, text, ms);
    } else {
      el.textContent = text;
    }
  }
  function play(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function () {});
  }

  /* Rail: step buttons and the 01 / 08 counter */
  function visible(list) {
    return [].filter.call(list.children, function (li) { return li.offsetWidth > 0; });
  }
  function step(list, items) {
    var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    return items[0].offsetWidth + gap;
  }
  function update(sec) {
    var list = sec.querySelector('.mx-col__list');
    var out = sec.querySelector('[data-count]');
    if (!list || !out) return;
    var items = visible(list);
    if (!items.length) return;
    var index = Math.min(items.length, Math.round(list.scrollLeft / step(list, items)) + 1);
    out.textContent = pad(index) + ' / ' + pad(items.length);
  }
  function refresh() {
    document.querySelectorAll('.mx-col--rail').forEach(update);
  }

  document.addEventListener('scroll', function (e) {
    var sec = e.target.closest ? e.target.closest('.mx-col--rail') : null;
    if (sec) update(sec);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-rail]') : null;
    if (!btn) return;
    var list = btn.closest('.mx-col').querySelector('.mx-col__list');
    var items = visible(list);
    if (!items.length) return;
    var s = step(list, items);
    var page = Math.max(1, Math.floor(list.clientWidth / s));
    list.scrollBy({ left: Number(btn.getAttribute('data-rail')) * s * page, behavior: reduce ? 'auto' : 'smooth' });
  });

  window.addEventListener('resize', refresh);
  window.addEventListener('load', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);

  /* Video: plays only while it is on screen */
  define('mx-video', class extends HTMLElement {
    connectedCallback() {
      var video = this.querySelector('video');
      if (!video) return;
      if (reduce) {
        video.controls = true;
        return;
      }
      video.muted = true;
      if (!('IntersectionObserver' in window)) {
        play(video);
        return;
      }
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(video);
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.2 });
      this._io.observe(this);
    }
    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }
  });

  /* Knit Lab readout: rows and machine time tick up */
  define('mx-readout', class extends HTMLElement {
    connectedCallback() {
      var rows = parseInt(this.dataset.rows, 10) || 0;
      var perMinute = parseFloat(this.dataset.rpm) || 0;
      var seconds = parseInt(this.dataset.time, 10) || 0;
      var rowsOut = this.querySelector('[data-rows-out]');
      var timeOut = this.querySelector('[data-time-out]');
      var carry = 0;

      function draw() {
        if (rowsOut) rowsOut.textContent = group(pad(rows, 5));
        if (timeOut) {
          timeOut.textContent =
            pad(Math.floor(seconds / 3600)) + ':' + pad(Math.floor(seconds / 60) % 60) + ':' + pad(seconds % 60);
        }
      }

      draw();
      if (reduce) return;
      this._timer = setInterval(function () {
        seconds++;
        carry += perMinute / 60;
        while (carry >= 1) {
          rows++;
          carry--;
        }
        draw();
      }, 1000);
    }
    disconnectedCallback() {
      clearInterval(this._timer);
    }
  });

  /* Edition ledger: decodes one limited product at a time */
  define('mx-ledger', class extends HTMLElement {
    connectedCallback() {
      var items = [];
      try {
        items = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) {}
      if (!items.length) return;

      var edOut = this.querySelector('.mx-led__ed');
      var nameOut = this.querySelector('.mx-led__name');
      var leftOut = this.querySelector('.mx-led__left');
      var prefix = this.dataset.prefix || '';
      var suffix = this.dataset.suffix || '';
      var seconds = Math.max(2, parseInt(this.dataset.seconds, 10) || 4);
      var index = 0;

      function show() {
        var item = items[index % items.length];
        index++;
        edOut.textContent = (prefix + ' ' + item.ed).trim();
        leftOut.textContent = (pad(item.left) + ' ' + suffix).trim();
        nameOut.href = item.url;
        decode(nameOut, item.n, 600);
      }

      show();
      if (items.length > 1) this._timer = setInterval(show, seconds * 1000);
    }
    disconnectedCallback() {
      clearInterval(this._timer);
    }
  });

  /* Freebie track: reads the freebie tiers of the cart drawer and follows the cart total.
     Desktop: a preview opens on hover or focus. Phones: the track is a swipe row, a tap opens the preview. */
  define('mx-ladder', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      var cfg = null;
      try {
        cfg = JSON.parse(document.getElementById('MxCartConfig').textContent);
      } catch (e) {}

      if (!cfg || !cfg.freebiesOn || !cfg.freebies || !cfg.freebies.length) {
        this.hidden = true;
        return;
      }
      this.cfg = cfg;
      this.firstRender = true;
      this.openFor = null;
      this.pop = this.querySelector('.mx-fl__pop');
      this.render(Number(cfg.subtotal) || 0);
      this.bindPreview();

      this._refetch = function () {
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { self.render(Number(cart.total_price) || 0); })
          .catch(function () {});
      };
      /* Dawn's pubsub (constants.js and pubsub.js): fires when products are added or changed */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, this._refetch);
      }
      /* Back from another tab or the browser back button */
      this._onShow = function () {
        if (document.visibilityState === 'visible') self._refetch();
      };
      document.addEventListener('visibilitychange', this._onShow);
      window.addEventListener('pageshow', this._refetch);
      this._onResize = function () { self.placeFill(); };
      window.addEventListener('resize', this._onResize);
    }
    disconnectedCallback() {
      if (typeof this._unsub === 'function') this._unsub();
      if (this._onShow) document.removeEventListener('visibilitychange', this._onShow);
      if (this._refetch) window.removeEventListener('pageshow', this._refetch);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onDoc) document.removeEventListener('click', this._onDoc);
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
    }
    isSwipe() {
      var scroll = this.querySelector('.mx-fl__scroll');
      return !!scroll && getComputedStyle(scroll).overflowX === 'auto';
    }
    render(cents) {
      var self = this;
      var cfg = this.cfg;
      var d = this.dataset;
      var shopifyCurrency = (window.Shopify && window.Shopify.currency) || {};
      var rate = parseFloat(shopifyCurrency.rate) || 1;
      var currency = cfg.currency || shopifyCurrency.active || 'EUR';
      var cart = cents / 100;
      /* Whole amounts without decimals (€250), others always with two (€204.50) */
      var lang = document.documentElement.lang || 'en';
      function fmt(n) {
        var whole = Math.abs(n % 1) < 0.005;
        try {
          return new Intl.NumberFormat(lang, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: whole ? 0 : 2,
            maximumFractionDigits: whole ? 0 : 2
          }).format(n);
        } catch (e) {
          return currency + ' ' + (whole ? n : n.toFixed(2));
        }
      }

      var tiers = cfg.freebies
        .map(function (f) { return { title: f.title, img: f.img || '', t: Math.round((Number(f.t) || 0) * rate) }; })
        .sort(function (a, b) { return a.t - b.t; });

      var nextFound = false;
      var gotCount = 0;
      var next = null;
      var nextIndex = -1;
      tiers.forEach(function (tier, i) {
        var got = cart > 0 && cart >= tier.t;
        tier.state = got ? 'got' : (nextFound ? 'locked' : 'next');
        tier.missing = Math.max(0, tier.t - cart);
        if (got) gotCount++;
        if (!got && !nextFound) { nextFound = true; next = tier; nextIndex = i; }
        tier.label = got
          ? (d.included || 'Included')
          : (tier.state === 'next'
            ? (tier.missing > 0 ? (d.togo || '[missing] to go').replace('[missing]', fmt(tier.missing)) : (d.any || 'With any order'))
            : (d.locked || 'Locked'));
        tier.from = (d.from || 'Free from [amount]').replace('[amount]', fmt(tier.t));
      });
      this.tiers = tiers;
      this.cart = cart;

      function fill(tpl) {
        return esc(tpl)
          .replace('[cart]', esc(fmt(cart)))
          .replace('[got]', gotCount)
          .replace('[count]', tiers.length)
          .replace('[missing]', next ? '<b>' + esc(fmt(next.missing)) : '')
          .replace('[next]', next ? esc(next.title) + '</b>' : '');
      }
      var status;
      if (cart <= 0) status = esc(d.empty || '');
      else if (!next) status = fill(d.done || '');
      else status = fill(d.progress || '');

      var statusEl = this.querySelector('[data-status]');
      var stepsEl = this.querySelector('[data-steps]');
      var countEl = this.querySelector('[data-got]');
      if (statusEl) statusEl.innerHTML = status;
      if (countEl) countEl.textContent = gotCount + ' / ' + tiers.length + ' ' + (d.countLabel || 'included');
      if (stepsEl) {
        stepsEl.style.setProperty('--mx-steps', tiers.length);
        stepsEl.innerHTML = tiers.map(function (tier, i) {
          return (
            '<button type="button" class="mx-fl__step is-' + tier.state + '" data-i="' + i + '" aria-expanded="false">' +
              '<span class="mx-fl__mark" aria-hidden="true"></span>' +
              '<span class="mx-fl__amt">' + esc(fmt(tier.t)) + '</span>' +
              '<span class="mx-fl__item">' + esc(tier.title) + '</span>' +
              '<span class="mx-fl__state">' + esc(tier.label) + '</span>' +
            '</button>'
          );
        }).join('');
      }
      this.nextIndex = nextIndex;
      this.closePreview();
      requestAnimationFrame(function () {
        self.placeFill();
        /* Phones: open the swipe row with the next freebie in view, the first time only */
        if (self.firstRender && self.isSwipe()) {
          var scroll = self.querySelector('.mx-fl__scroll');
          var steps = self.querySelectorAll('.mx-fl__step');
          var target = nextIndex > 0 ? steps[nextIndex - 1] : (nextIndex === -1 ? steps[steps.length - 1] : null);
          if (scroll && target) scroll.scrollLeft = target.offsetLeft - parseFloat(getComputedStyle(scroll).paddingLeft || 0);
        }
        self.firstRender = false;
      });
    }
    /* The fill runs through the real marker positions, so it is right on desktop and in the swipe row */
    placeFill() {
      var inner = this.querySelector('.mx-fl__inner');
      var fillEl = this.querySelector('[data-fill]');
      var marks = this.querySelectorAll('.mx-fl__mark');
      if (!inner || !fillEl || !marks.length || !this.tiers) return;
      var base = inner.getBoundingClientRect().left;
      var xs = [].map.call(marks, function (m) {
        var r = m.getBoundingClientRect();
        return r.left - base + r.width / 2;
      });
      var cart = this.cart;
      var tiers = this.tiers;
      var x = 0;
      if (cart > 0) {
        x = inner.getBoundingClientRect().width;
        for (var i = 0; i < tiers.length; i++) {
          if (cart < tiers[i].t) {
            if (i === 0) { x = 0; break; }
            var part = (cart - tiers[i - 1].t) / Math.max(1, tiers[i].t - tiers[i - 1].t);
            x = xs[i - 1] + (xs[i] - xs[i - 1]) * part;
            break;
          }
        }
      }
      fillEl.style.width = Math.max(0, x) + 'px';
    }
    openPreview(step) {
      var pop = this.pop;
      if (!pop || !this.tiers) return;
      var tier = this.tiers[Number(step.getAttribute('data-i'))];
      if (!tier) return;
      var img = pop.querySelector('img');
      pop.className = 'mx-fl__pop is-open is-' + tier.state + (tier.img ? '' : ' no-img');
      if (tier.img) {
        img.src = tier.img;
        img.alt = tier.title;
      }
      pop.querySelector('.mx-fl__pop-name').textContent = tier.title;
      pop.querySelector('.mx-fl__pop-from').textContent = tier.from;
      pop.querySelector('.mx-fl__pop-tag').textContent = tier.label;

      if (!this.isSwipe()) {
        var body = this.querySelector('.mx-fl__body').getBoundingClientRect();
        var s = step.getBoundingClientRect();
        var room = body.right - s.left;
        if (room < 350) {
          pop.style.left = 'auto';
          pop.style.right = Math.max(0, body.right - s.right) + 'px';
        } else {
          pop.style.right = 'auto';
          pop.style.left = (s.left - body.left) + 'px';
        }
      }
      this.querySelectorAll('.mx-fl__step').forEach(function (x) { x.setAttribute('aria-expanded', x === step); });
      this.openFor = step;
    }
    closePreview() {
      if (this.pop) this.pop.classList.remove('is-open');
      this.querySelectorAll('.mx-fl__step').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      this.openFor = null;
    }
    bindPreview() {
      var self = this;
      var hoverable = window.matchMedia('(hover: hover)').matches;
      this.addEventListener('mouseover', function (e) {
        if (!hoverable || self.isSwipe()) return;
        var step = e.target.closest('.mx-fl__step');
        if (step && step !== self.openFor) self.openPreview(step);
      });
      this.addEventListener('mouseleave', function () {
        if (hoverable && !self.isSwipe()) self.closePreview();
      });
      this.addEventListener('focusin', function (e) {
        var step = e.target.closest('.mx-fl__step');
        if (step && step !== self.openFor) self.openPreview(step);
      });
      this.addEventListener('click', function (e) {
        var step = e.target.closest('.mx-fl__step');
        if (!step) return;
        if (step === self.openFor && (self.isSwipe() || !hoverable)) self.closePreview();
        else self.openPreview(step);
      });
      this._onDoc = function (e) {
        if (self.openFor && !self.contains(e.target)) self.closePreview();
      };
      this._onKey = function (e) {
        if (e.key === 'Escape') self.closePreview();
      };
      document.addEventListener('click', this._onDoc);
      document.addEventListener('keydown', this._onKey);
    }
  });

  /* Glitch: for a short burst the red and cyan copies are cut into random slices and shifted sideways */
  function glitch(box, ms, px) {
    if (reduce || !box || !box.classList.contains('has-img')) return;
    var layers = box.querySelectorAll('.mx-glitch__layer');
    var start = performance.now();
    var last = 0;
    box.classList.add('is-glitching');
    cancelAnimationFrame(box._mxG);
    function frame(now) {
      if (now - start >= ms) {
        box.classList.remove('is-glitching');
        layers.forEach(function (l) { l.style.clipPath = ''; l.style.transform = ''; });
        return;
      }
      if (now - last > 50) {
        last = now;
        layers.forEach(function (l) {
          var top = Math.random() * 80;
          var h = 5 + Math.random() * 25;
          l.style.clipPath = 'inset(' + top.toFixed(1) + '% 0 ' + Math.max(0, 100 - top - h).toFixed(1) + '% 0)';
          l.style.transform = 'translateX(' + ((Math.random() * 2 - 1) * px).toFixed(1) + 'px)';
        });
      }
      box._mxG = requestAnimationFrame(frame);
    }
    box._mxG = requestAnimationFrame(frame);
  }

  /* Alt text for pulled products, same rules as snippets/mxdvs-image-alt.liquid */
  function altFor(p, image) {
    if (image && image.alt && image.alt !== p.title) return image.alt;
    var colour = '';
    (p.options || []).forEach(function (o) {
      var n = String(o.name || '').toLowerCase();
      if (/colo|kleur|couleur|farbe/.test(n) && o.values && o.values.length) colour = String(o.values[0]).toLowerCase();
    });
    var desc = (colour + ' ' + String(p.product_type || '').toLowerCase()).trim();
    return p.title + ' by MXDVS' + (desc ? ', ' + desc : '');
  }
  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* Dates: YYYY-MM-DD to MAR 2020 */
  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  function formatDate(iso) {
    var m = /^(\d{4})-(\d{2})/.exec(iso || '');
    return m ? MONTHS[Number(m[2]) - 1] + ' ' + m[1] : '';
  }

  /* Pull a file: the number spins, lands on the file, the photo glitches in, then the name and dates decode */
  define('mx-archive-pull', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.button = this.querySelector('[data-pull]');
      this.num = this.querySelector('[data-num]');
      this.name = this.querySelector('[data-name]');
      this.open = this.querySelector('[data-open]');
      this.box = this.querySelector('.mx-glitch');
      this.img = this.querySelector('.mx-glitch__img');
      this.who = this.querySelector('.mx-pf__who');
      this.released = this.querySelector('[data-released]');
      this.sold = this.querySelector('[data-sold]');
      this.soldLabel = this.querySelector('[data-sold-label]');
      this.handle = this.dataset.handle;
      this.total = parseInt(this.dataset.total, 10) || 0;
      this.glitchMs = parseInt(this.dataset.glitchMs, 10) || 450;
      this.glitchPx = parseFloat(this.dataset.glitchPx) || 8.5;
      this.idle = parseFloat(this.dataset.glitchIdle) || 0;
      this.blockedVendors = [];
      try {
        this.blockedVendors = JSON.parse(this.querySelector('script[type="application/json"]').textContent)
          .map(function (v) { return String(v).trim().toLowerCase(); })
          .filter(Boolean);
      } catch (e) {}
      if (!this.button || !this.num || !this.handle || !this.total) return;
      this.button.addEventListener('click', function () {
        if (!self._busy) self.pull();
      });
      if (this.idle > 0 && !reduce) {
        this._idle = setInterval(function () {
          if (!document.hidden) glitch(self.box, self.glitchMs * 0.6, self.glitchPx);
        }, this.idle * 1000);
      }
      this.matchLadder();
      this.matchPhoto();
    }
    disconnectedCallback() {
      clearInterval(this._idle);
      if (this._ro) this._ro.disconnect();
      if (this._roWho) this._roWho.disconnect();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }
    /* The photo is a square as tall as the text block next to it, and follows it when a name wraps */
    matchPhoto() {
      var self = this;
      if (!this.who) return;
      function apply() {
        var h = Math.round(self.who.getBoundingClientRect().height);
        if (h > 0) self.style.setProperty('--mx-who-h', h + 'px');
      }
      if ('ResizeObserver' in window) {
        this._roWho = new ResizeObserver(apply);
        this._roWho.observe(this.who);
      }
      requestAnimationFrame(apply);
    }
    /* Released and last sold, from templates/product.mxdvs-file.liquid.
       No JSON Accept header here: with that header Shopify answers with its own product data
       instead of running the template. If that standard data still comes back, the release date
       is taken from it (published or created date), so the line never stays empty. */
    fetchDates(handle, fallback) {
      function fromShopify(p) {
        if (!p) return null;
        return { released: String(p.published_at || p.created_at || '').slice(0, 10), lastSold: null };
      }
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=mxdvs-file')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var data = null;
          try { data = JSON.parse(String(t).trim()); } catch (e) {}
          if (data && data.released) return data;
          if (data && data.product) return fromShopify(data.product);
          return fromShopify(fallback);
        })
        .catch(function () { return fromShopify(fallback); });
    }
    showDates(dates) {
      var released = formatDate(dates && dates.released);
      var sold = formatDate(dates && dates.lastSold);
      if (this.released) decode(this.released, released || '----', 600);
      if (this.sold && this.soldLabel) {
        this.sold.hidden = this.soldLabel.hidden = !sold;
        if (sold) decode(this.sold, sold, 600);
      }
    }
    /* Phones: take the height of the freebie track, from its title to the bottom of the swipe row */
    matchLadder() {
      var self = this;
      var strip = this.closest('.mx-end');
      var ladder = strip ? strip.querySelector('mx-ladder') : null;
      if (!ladder) return;
      function apply() {
        var scroll = ladder.querySelector('.mx-fl__scroll');
        var phone = !!scroll && getComputedStyle(scroll).overflowX === 'auto' && !ladder.hidden;
        if (phone) {
          self.style.setProperty('--mx-pf-h', Math.round(ladder.getBoundingClientRect().height) + 'px');
        } else {
          self.style.removeProperty('--mx-pf-h');
        }
      }
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(apply);
        this._ro.observe(ladder);
      }
      this._onResize = apply;
      window.addEventListener('resize', apply);
      requestAnimationFrame(apply);
    }
    fetchOne(tries) {
      var self = this;
      var page = 1 + Math.floor(Math.random() * this.total);
      return fetch(root + 'collections/' + encodeURIComponent(this.handle) + '/products.json?limit=1&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var p = data && data.products && data.products[0];
          var vendor = p ? String(p.vendor || '').trim().toLowerCase() : '';
          if (!p || p.handle === 'free-gift' || self.blockedVendors.indexOf(vendor) > -1) {
            return tries < 3 ? self.fetchOne(tries + 1) : null;
          }
          return self.fetchDates(p.handle, p).then(function (dates) {
            return { page: page, product: p, dates: dates };
          });
        });
    }
    show(hit) {
      var p = hit.product;
      var image = p.images && p.images[0];
      this.num.textContent = pad(hit.page, 4);
      if (image && image.src && this.img && this.box) {
        var src = sized(image.src, 400);
        this.img.src = src;
        this.img.alt = altFor(p, image);
        this.img.hidden = false;
        this.box.style.setProperty('--mx-img', 'url("' + src + '")');
        this.box.classList.add('has-img');
        glitch(this.box, this.glitchMs, this.glitchPx);
      }
      decode(this.name, String(p.title).toUpperCase(), 700);
      this.showDates(hit.dates);
      if (this.open) {
        this.open.href = root + 'products/' + encodeURIComponent(p.handle);
        this.open.hidden = false;
        if (!this._openText) this._openText = this.open.textContent.trim();
        decode(this.open, this._openText, 500);
      }
    }
    pull() {
      var self = this;
      var start = performance.now();
      var landed = false;
      this._busy = true;
      this.button.setAttribute('aria-busy', 'true');
      this.name.innerHTML = '&nbsp;';
      if (this.open) this.open.hidden = true;

      function spin() {
        if (landed) return;
        self.num.textContent = pad(Math.floor(Math.random() * 10000), 4);
        requestAnimationFrame(spin);
      }
      if (!reduce) requestAnimationFrame(spin);

      this.fetchOne(0)
        .then(function (hit) {
          var wait = reduce ? 0 : Math.max(0, 700 - (performance.now() - start));
          setTimeout(function () {
            landed = true;
            if (!hit) {
              self.num.textContent = '0000';
              return;
            }
            self.show(hit);
          }, wait);
        })
        .catch(function () {
          landed = true;
          self.num.textContent = '0000';
        })
        .then(function () {
          setTimeout(function () {
            self._busy = false;
            self.button.removeAttribute('aria-busy');
          }, 750);
        });
    }
  });

  window.MxHome = { refresh: refresh };
})();
